import { FamilyUnit, PossibleEmployerContributionDto } from '@zorro/clients';
import { Title } from '@zorro/design-system/v2/Title';
import { Stack } from '@zorro/web/design-system';
import { useImpersonation, useRoles } from '@zorro/web/ui-utils';

import { PersonalizedAllowanceTooltip } from './PersonalizedAllowanceTooltip';

type Props = {
  possibleEmployerContributions: PossibleEmployerContributionDto[];
};

export const AllowanceBasedTooltip = ({
  possibleEmployerContributions,
}: Props) => {
  const { isEmployeeOnlyRole } = useRoles();
  const { isImpersonated } = useImpersonation();
  const isSelfView = isEmployeeOnlyRole || isImpersonated;
  return (
    <Stack gap="0.25rem">
      <Title order={3}>
        {`${isSelfView ? 'Your' : "Employee's"} allowance, based on who is covered`}
      </Title>
      <Stack gap="0rem">
        {Object.values(FamilyUnit).map((familyUnit) => {
          return (
            <PersonalizedAllowanceTooltip
              key={familyUnit}
              familyUnit={familyUnit}
              possibleEmployerContributions={possibleEmployerContributions}
            />
          );
        })}
      </Stack>
    </Stack>
  );
};
